import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UiMeet3dEvent from "~/models/UiMeet3d/UiMeet3dEvent";
import UiMeet3dEventTypeLabel from "./UiMeet3dEventTypeLabel";

@observer
class UiMeet3dEventList extends Component {
  render() {
    const { uiMeet3dEvents, onUiMeetEventDetailsClicked, t } = this.props;

    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("clientPanelMisc:type")}</Table.HeaderCell>
            <Table.HeaderCell>{t("clientPanelMisc:tour")}</Table.HeaderCell>
            <Table.HeaderCell>{t("date")}</Table.HeaderCell>
            <Table.HeaderCell />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {uiMeet3dEvents.length === 0 && (
            <Table.Row>
              <Table.Cell colSpan={4} textAlign="center">
                <p>{t("clientPanelMisc:noRecordedEvent")}</p>
              </Table.Cell>
            </Table.Row>
          )}
          {uiMeet3dEvents.length > 0 &&
            uiMeet3dEvents.map(uiMeet3dEvent => (
              <Table.Row key={uiMeet3dEvent.uiMeet3dEventId}>
                <Table.Cell>
                  <UiMeet3dEventTypeLabel type={uiMeet3dEvent.type} />
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/tours/${uiMeet3dEvent.tourId}`}>{uiMeet3dEvent.tourId}</Link>
                </Table.Cell>
                <Table.Cell>{uiMeet3dEvent.creationDts.format("llll")}</Table.Cell>
                <Table.Cell textAlign="center" width="1">
                  <Button
                    onClick={() => {
                      onUiMeetEventDetailsClicked(uiMeet3dEvent);
                    }}
                  >
                    {t("clientPanelMisc:details")}
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    );
  }
}

UiMeet3dEventList.propTypes = {
  t: PropTypes.func.isRequired,
  uiMeet3dEvents: PropTypes.arrayOf(PropTypes.instanceOf(UiMeet3dEvent)),
  onUiMeetEventDetailsClicked: PropTypes.func.isRequired,
};

export default withTranslation()(UiMeet3dEventList);
